"use client";

import type { PickleballTemplateData } from "../pickleball-template";
import { ActivityCourtPreview } from "./activity-court-preview";

type PickleballDisplayPreviewProps = {
  data: PickleballTemplateData | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function PickleballDisplayPreview({
  data,
  participants,
}: PickleballDisplayPreviewProps) {
  if (!data) {
    return (
      <ActivityCourtPreview
        activityId="pickleball"
        mode="doubles"
        yourTeam={[]}
        opponentTeam={[]}
      />
    );
  }

  const yourTeam = participants
    .filter((p) => data.positions[p.id] === "your-team")
    .map((p) => ({ ...p, handle: p.username ?? undefined }));
  const opponentTeam = participants
    .filter((p) => data.positions[p.id] === "opponent-team")
    .map((p) => ({ ...p, handle: p.username ?? undefined }));

  const showScore = data.hasScore !== false;
  const yourWon = data.matchScore.yourGames > data.matchScore.opponentGames;

  return (
    <div>
      <ActivityCourtPreview
        activityId="pickleball"
        data={data}
        mode={data.mode ?? "doubles"}
        yourTeam={yourTeam}
        opponentTeam={opponentTeam}
        yourWon={showScore ? yourWon : undefined}
        showLabels={false}
        linkToProfiles
      />
    </div>
  );
}
